<template>
    <div>
        <a-page-header class="page-header icon" title="个人中心" @back="() => null">
            <svg
                class="icon"
                aria-hidden="true"
                slot="backIcon"
                @click="$router.replace('/profile')"
            >
                <use xlink:href="#icon-geren" />
            </svg>
        </a-page-header>

        <div class="framework-container">
            <a-form-model :label-col="label_col" :wrapper-col="wrapper_col" class="form">

                <a-form-model-item label="头像" prop="avatar" extra="推荐使用200*200的正方形图片">
                <a-upload
                    class="img-uploader-avatar"
                    list-type="picture-card"
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    :show-upload-list="false"
                    @change="(info)=>on_upload_change(info,'avatar')"
                    :headers="{'x-identity':'manager'}"
                    accept="image/png, image/jpeg"
                >
                    <img v-if="form.avatar" :src="form.avatar" class="favicon" style="width: 100%;" />
                    <div class="upload" v-else>
                        <a-icon :type="uploading_avatar ? 'loading' : 'plus'" />

                        <div class="ant-upload-text">上传头像</div>
                    </div>
                </a-upload>
            </a-form-model-item>


                <a-form-model-item label="用户名">
                    <a-input type="text" v-model="form.name" />
                </a-form-model-item>

                <!-- <a-form-model-item label="登录密码">
                    <a-input type="text" v-model="form.password" placeholder="留空则不修改" />
                </a-form-model-item> -->

                <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                    <a-button type="primary" :disabled="submitting" @click="on_submit">保存</a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
    </div>
</template>

<script>
import env from "../../../env";


export default {
    data() {
        return {
            label_col: { span: 4 },
            wrapper_col: { span: 14 },
            submitting: false,
            loading:false,
            data_source:{},
            action: env.base_url + "service/upload",
            uploading_avatar: false,
            form: {
                name:null,
                password:null,
                avatar:null
            }
        };
    },
    created(){
        this.load()
    },
    methods: {
        load() {
            this.loading = true
            this.$http.get('/personal/profile').then(res=>{
                if(res.success)
                {
                    this.$store.commit("changeProfile", res.data);

                    this.form = {
                        name:res.data.name,
                        avatar:res.data.avatar
                    }
                }
            }).catch(()=>{}).then(()=>{
                this.loading = false
            })
        },
        on_submit() {
            this.submitting = true;
            this.$http
                .post("/personal/profile", this.form)
                .then(res => {
                    if (res.success) {
                        this.$message.success(res.message)
                        this.form.password = null

                        this.load()
                    } else {
                        this.$error({ title: "失败", content: res.message });
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.submitting = false;
                });
        },
        on_upload_change(info, field) {
            if (info.file.status === "uploading") {
                this["uploading_" + field] = true;
                return;
            }
            if (info.file.status === "done") {
                this["uploading_" + field] = false;
                if (info.file.response.success) {
                    this.form[field] = info.file.response.data.url;
                } else {
                    this.$error({
                        title: "失败",
                        content: info.file.response.message
                    });
                }
            } else if (info.file.status === "error") {
                this.$message.error(`${info.file.name} 上传失败.`);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.form {
    padding-top:24px;
    max-width: 600px;

    .img-uploader-avatar{
        /deep/.ant-upload{
            /deep/.ant-upload{
                padding:0;
            }
        }
    }
}
</style>